import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { GzDashboardAppController } from '../controller/GzDashboardAppController';
import { translateFn } from '../../../utils/translator.helper';
import { dashboardsWithExtJSInjection } from '../types';
import { DisplayMode } from '../../../types/common/types';
import { Target } from '@nirvana/shared/dtos/types/dashboards/common';

export class GzDashboardAppWebComponent extends BaseWebComponentElement {
  private static readonly INVALID_DASHBOARD_TYPE = -1;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: GzDashboardAppController,
    });

    if (dashboardsWithExtJSInjection.includes(this.dashboardType)) {
      return;
    }

    this.injectDependencies({
      api: { type: 'nirvana' },
      translateFn: translateFn,
    });
  }

  injectDependencies(dependencies: any) {
    if (this.dependenciesInjected) {
      return;
    }
    this.dependencies = dependencies;
    this.build();
    this.dependenciesInjected = true;
  }

  get dashboardType(): number {
    const value = this.getAttribute('data-dashboard-type');
    if (value) {
      return parseInt(value, 10);
    }
    return GzDashboardAppWebComponent.INVALID_DASHBOARD_TYPE;
  }

  set dashboardType(value: number) {
    this.setAttribute('data-dashboard-type', value.toString());
  }

  get displayMode(): DisplayMode {
    const value = this.getAttribute('data-display-mode');
    return value ? <DisplayMode>value : DisplayMode.DASHBOARD;
  }

  set displayMode(value: DisplayMode) {
    if (!value) {
      return;
    }
    this.setAttribute('data-display-mode', value);
  }

  get selectedTarget(): Target {
    const value = this.getAttribute('data-selected-target');
    return value ? JSON.parse(value) : {};
  }

  set selectedTarget(value: Target | undefined) {
    if (!value) {
      this.removeAttribute('data-selected-target');
      return;
    }
    this.setAttribute('data-selected-target', JSON.stringify(value));
  }
}
